import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { fetchWorkdays, filterAction, resetFilterAction } from '../actions/index';
import HoursOfServiceModal from './hours-of-service-modal';
import NonCertifiedEmployeesWorkday from './non-certified-employees-workday';
import * as apiConstants from '../../../constants/const';
import ActivityModal from './activity-modal';
import CommentsModal from './comments-modal';
import AdminCommonSection from '../components/adminLayout';
import {Filters, Pagination, constants, KeolisSpinner, moment} from './common/commonExport';
import PDFPrinting from './PDFPrinting';

class Outlaw extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            totalRecords: '',
            numberOfPages: 0,
            pageNum: 1, 
            filterState:{}
        }
    }

   // get data for component
    getData(pageNum, filterObj){
        if(filterObj){
            filterObj = filterObj;
        } else {
            filterObj = this.state.filterState;
        }
        filterObj['outlaw'] = true;
        let self = this,
            authDetails = this.props.authDetails,
            role = authDetails.role;            
            pageNum = filterObj.byPagination ? (pageNum) : (filterObj.byFilter ? 1 : pageNum);
        if(role == constants.roles.ADMIN_ROLE){
            let fetchObj = {
                url:constants.actionUrls.ADMIN_URL,
                role: role,
                certifyStatus: constants.OUTLAW,
                pageNum:pageNum,
                filterObj:filterObj
            }
            this.props.fetchWorkdays(fetchObj, function(response){
                self.setState({
                    numberOfPages: response.totalPages,
                    pageNum: pageNum
                })
            });
            localStorage.setItem('route', constants.OUTLAW);
        }
    };

    // resetting the filter component
    resetFilter(filterObj){
        let self = this;  
        filterObj['outlaw'] = true; 
        this.props.resetFilter(filterObj, function(response){
            self.setState({
                filterState:response
            });
        });
    }
    //called before the component renders
    componentWillMount() {
        let filterObj = this.props.filterState.defaultState ? this.props.filterState.defaultState:
                        this.props.filterState;
        this.resetFilter(filterObj);
    }
    //called after the component renders
    componentDidMount(){
        let pageNum = this.state.pageNum;
        this.getData(pageNum);
    }
    // show different modal as per needed
    renderModal() {
        if (this.props.showModal && this.props.modalName == constants.hosModals.Certified_Modal) {
            return (
                <HoursOfServiceModal workday={this.props.workday} />
            )
        } else if (this.props.showModal && this.props.modalName == constants.hosModals.Certify_Modal) {
            return (
                <ActivityModal />
            )
        } else if (this.props.modalName == constants.hosModals.Comments_Modal) {
            return (
                <CommentsModal />
            )
        }
    }
    // rendering pagination component
    renderPagination() {
        let { pageNum, numberOfPages} = this.state,
            workdays = this.props.workdays, showPagination=false;
        if(workdays && workdays && workdays.length > 0 && numberOfPages > 1){
            showPagination = true;
        }
        return (<Pagination ShowPagination={showPagination} currentPage={pageNum}
            pageSize={numberOfPages} GetData={(pageNum, filterObj) => this.getData(pageNum, filterObj)} />)
    }
    // render workdays component
    renderWorkdays() {
        var wdy_date, then, role = this.props.authDetails.role;
        if (this.props.isLoading) {
            return(
                <tr>
                    <td>
                        <KeolisSpinner />
                    </td>
                </tr>
            )
        }
        else if (this.props.workdays && this.props.workdays.length >= 0) {
            if (this.props.paginationState) {
                var paginationState = this.props.paginationState.paginationState;
            }
            var workdays = this.props.workdays;           
            return (
                workdays.length == 0 ?
                <tr>
                    <td colSpan="100%">
                        No records available...
                    </td>
                </tr>
                    :
                    workdays.map(function (workday, index) {
                        return (
                            <NonCertifiedEmployeesWorkday workday={workday} key={index} role={role} />
                        );
                    })
            )
        } else {
            return (
                <tr>
                    <td colSpan="100%">
                        <KeolisSpinner  />
                    </td>
                </tr>
            )
        }
    }
    // filter in action
    getFilteredData(e, data){
        let pageNum = this.state.pageNum,filterObj = data;
        if(e){
            e.preventDefault();
        } 
        this.props.submitFilter(data);
        this.getData(pageNum, filterObj);
    }

    render() {
        var route = localStorage.getItem('route') ? localStorage.getItem('route') : '',
            compTitle = constants.getComponentTitle(route);
        return (
            <AdminCommonSection compTitle={compTitle} admin={true}
                tblBody={
                    <div>
                        <Filters getData = {(e, data) => this.getFilteredData(e, data)}/>
                        <PDFPrinting Page="Projects" compTitle = {compTitle} pageNo = {this.state.pageNum}/>
                        <div id="tblMainActivities">
                            <table className="table table-striped table-bordered_header table-condensed">
                            <thead className="thead-default">
                                <tr>
                                    <th>Division</th>
                                    <th className="text-center">Employee ID</th>
                                    <th className="text-center">Job</th>                                    
                                    <th className="text-center">First Name</th>
                                    <th className="text-center">Last Name</th>
                                    <th className="text-center">Service Date</th>
                                    <th className="text-center">Phone</th>
                                    <th className="text-center">HOS</th>
                                    <th className="text-center">TOS</th>
                                   
                                </tr>
                            </thead>
                            <tbody>
                            {
                                this.renderWorkdays()
                            }
                            </tbody>
                            </table>
                            {
                                this.renderModal()
                            }
                            </div>
                            { 
                                this.renderPagination()
                            }
                            </div>
                    }
            />
        )
    }
}

function mapStateToProps(state) {
    return {
        workdays: state.workdays.workdays,
        isLoading: state.workdays.isLoading,
        showModal: state.modals.showModal,
        modalName: state.modals.modalName,
        workday: state.workday.workday,
        authDetails:state.authState,
        filterState:state.filter
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            fetchWorkdays: fetchWorkdays,
            submitFilter: filterAction,
            resetFilter:resetFilterAction}, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Outlaw);
